
import { useState, useEffect } from "react";


import input_check from "../input_check.png";
import input_error from "../input_error.png";


function InputEmail(props)
{

 
 

    const [val, setVal] = useState(props.value);
    const [req, setRequired] = useState(props.req);
    const [cn, setClassName] = useState('');

    const [onShow,setOnShow] = useState(false);


    const validateEmail = (email) => {
        return String(email)
          .toLowerCase()
          .match(
            /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|.(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
          );
      };


    const checkAndChange = (e) =>
    {
        var v = e.target.value;

        v = v.replace("ą","a");
        v = v.replace("Ą","A");
        v = v.replace("ś","s");
        v = v.replace("Ś","S");
        v = v.replace("ć","c");
        v = v.replace("Ć","C");
        v = v.replace("ż","z");
        v = v.replace("Ż","Z");
        v = v.replace("ź","z");
        v = v.replace("Ź","Z");
        v = v.replace("ó","o");
        v = v.replace("Ó","O");
        v = v.replace("ł","l");
        v = v.replace("Ł","L");

        setVal(v);

        var correct = false;

        if(req == '1' && v.length < 1) correct = false;         
        if(req == '0' && v.length < 1) correct = true;
        

        if(v.length > 0 && validateEmail(v) )
        {
            correct = true;
        }
                        
        
        if(correct == false)
        {
            setClassName('incorrent');
        }else
        {
            setClassName('corrent');           
        }

        if(props.valChange != null && props.valChange != undefined)
        {
            props.valChange(props.name, v, correct,'');
        }else
        {
            console.log('No support for valChange');
        }    
    }

    const onKeyDown = (e) => {
        if (e.key === 'Enter') {
               if(props.goNext != null && props.goNext != undefined)
               {
                  props.goNext();
               }
          } 
    }


    if(cn.length < 2)
    {
        var correct = true;
        
        if(req == '1' &&  val != undefined  &&  !validateEmail(val) ) correct = false;         
    
      
        if(correct == false)
        {
            setClassName('incorrent');
        }else
        {
            setClassName('corrent');           
        }
    }

    var imgx = null;

    if(cn == "incorrent" && req=='1')
    {
        imgx = <img  className="input_status" src={input_error} />
    }

    
    if(cn == "corrent" && req=='1')
    {
        imgx = <img className="input_status" src={input_check} />
    }

    useEffect(() => {

        if(val != props.value) //aktualizuj jesli sie zmieni..
        {
            setVal(props.value);
            setOnShow(false);
        }

        if( onShow == false && props.valChange != null && props.valChange != undefined ) //sprawdz czy dane sa poprawne i wyslij wyzej
        {
             var correct = true;
             if(cn == "incorrent" ) correct = false;                 
             setOnShow(true);
             props.valChange(props.name, val, correct,'');
    
        }
    })

    var valFormat =  val;

    var err = "";
    if(props.err != undefined  &&  props.err != null ) 
    {       
        if(props.err[props.name] != null  && props.err[props.name] != undefined    ) err = props.err[props.name]['param'];
    }



    var cnX = cn;
    if( val != null &&  val.length < 1 && cnX == 'corrent')
        {
            cnX = '';
        }

    return <fieldset>
        <input type="email"  value={val} onChange={checkAndChange} onKeyDown={onKeyDown} name={props.name} placeholder={props.placeholder} className={props.className + " w250 " + cnX} />        
        {imgx}
        <br/>
             <span className="form_err">{err + " "} &nbsp; </span>        
    </fieldset>
}


export default InputEmail;